import styled from "styled-components";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import pages from "../../../constants/pages";
import { PrimaryButton } from "../../css components/Button";

const ExploreButton = styled(PrimaryButton)`
  background-color: #1a56db;
  text-transform: none;
  font-weight: 500;
  border-radius: 6px;
  padding: 6px 16px;

  &:hover {
    background-color: #174dc4;
  }
`;

const Card = styled(Box)`
  width: 100%;
  max-width: 400px;
  padding: 24px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 4px 12px #376fd033;
  border: 1px solid #e0e0e0;
  transition: transform 0.3s ease;
  margin: 40px auto;
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 6px 16px #376fd055;
  }
`;

export default function WelcomeCardAgency({ steps }) {
  const navigate = useNavigate();
  const agencyID = sessionStorage.getItem("agencyID");

  return (
    <Card>
      <Typography className="card-heading">
        {!steps.step2
          ? "Let's start by adding the agency details."
          : "Your agency details has been added, Do you want to edit it?"}
      </Typography>
      <ExploreButton
        onClick={() => handleBrandNavigation()}
        variant="contained"
      >
        {!steps.step2 ? "Add Agency Details" : "Edit Agency Details"}
      </ExploreButton>
    </Card>
  );

  function handleBrandNavigation() {
    if (steps.step2) {
      navigate(pages.agencyDetailsEmptyPage.route + "?agencyID=" + agencyID);
    } else {
      navigate(pages.createAgencyPage.route);
    }
  }
}
